import { Component, Prop, Vue } from 'vue-property-decorator';
@Component({ components: {} })
export default class SpendingState extends Vue {
  @Prop() private suggestionsList!: any;
  @Prop({ default: false }) private showSuggested!: boolean;
}
